import { Grid, Typography } from '@mui/material';
import modelo_parte1 from '../images/modelo_parte1.png';
import modelo_parte2 from '../images/modelo_parte2.png';
import modelo_parte3 from '../images/modelo_parte3.png';
import '../styles/Page2.css';

export function Page2() {
  return (
    <Grid container className="page2-root"  position="relative" spacing={0}>

      <Grid xs={12}>
        <Typography variant="h5" component="div" align="left" className="legend-conceptuals" position="absolute" sx={{ display: { xs: 'block', md: 'none' } }}>
          Conceptual
        </Typography>
        <Typography variant="h4" component="div" align="left" className="legend-conceptuals" position="absolute" sx={{ display: { xs: 'none', md: 'block' } }}>
          Conceptual
        </Typography>
      </Grid>

      <Grid container size={{ xs: 12, md: 12 }} border={"solid #A2D6F8"} spacing={2} >
        <Grid xs={12} md={2} display="flex" alignItems="center" justifyContent="center" borderRight={"solid #A2D6F8"}>

          <Typography variant='h4' component='h3' color='white' align='center' sx={{
            fontSize: { xs: '20px', md: '30px' },
            writingMode: 'vertical-rl',
            transform: 'rotate(180deg)',
            py: { xs: "30px", md: "20px" },
          }}
          >Data</Typography>

        </Grid>
        <Grid xs={12} md={10} display="flex" justifyContent="center" className="img-conceptual">
          <img src={modelo_parte1} alt="Parte 1" className="img-conceptual1" />
        </Grid>

      </Grid>



      <Grid container size={{ xs: 12, md: 12 }} border={"solid #A2D6F8"} borderTop="none" spacing={2}>
        <Grid item xs={12} md={2} display="flex" alignItems="center" justifyContent="center" borderRight={"solid #A2D6F8"}>

          <Typography variant='h4' component='h3' color='white' align='center' sx={{
            fontSize: { xs: '20px', md: '30px' },
            py: { xs: "8px", md: "20px" },
            writingMode: 'vertical-rl',
            transform: 'rotate(180deg)',

          }}>Information</Typography>

        </Grid>
        <Grid xs={12} md={10} display="flex" justifyContent="center" className="img-conceptual">
          <img src={modelo_parte2} alt="Parte 2" className="img-conceptual2" />
        </Grid>
      </Grid>

      <Grid container size={{ xs: 12, md: 12 }} border={"solid #A2D6F8"} borderTop="none" spacing={2}>
        <Grid item xs={12} md={2} display="flex" alignItems="center" justifyContent="center" borderRight={"solid #A2D6F8"}>

          <Typography variant='h4' component='h3' color='white' align='center' sx={{
            fontSize: { xs: '20px', md: '30px' },
            writingMode: 'vertical-rl',
            transform: 'rotate(180deg)',
          }}>Knowledge</Typography>

        </Grid>
        <Grid item xs={12} md={10} display="flex" justifyContent="center" className="img-conceptual" >
          <img src={modelo_parte3} alt="Parte 3" className="img-conceptual3" />
        </Grid>
      </Grid>
    </Grid>
  );
};
